const Container: React.FC<any> = (props: any) => (
  <div className="flex flex-col justify-start color-[#fff]" {...props}></div>
);
export default Container;
